import { computed, useStore } from '@nuxtjs/composition-api'

const comp = require(`../${process.env.TEMPLATE_ID}/comp.json`)

export default function useComp() {
  const store = useStore()

  const webEnv = computed(() => process.env.WEB_ENV)
  const isDev = computed(() => webEnv.value !== 'prod')
  const locale = computed(() => store.state.locale)
  const compId = computed(() => process.env.COMP_ID)
  const compName = computed(() => process.env.COMP_NAME)
  const compAppLink = computed(() => process.env.APP_DOWNLOAD_LINK)
  const compAdultAge = computed(() => comp[compId.value].adultAge)
  const compHead = computed(() => comp[compId.value].head)
  const compFooterPlatforms = computed(() => comp[compId.value].footerPlatforms)
  const compFooterPayments = computed(() => comp[compId.value].footerPayments)
  const compUserLevels = computed(() => comp[compId.value].userLevels)
  const compVipLevels = computed(() => compUserLevels.value[locale.value])

  const compVipLevelsList = computed(
    () => compUserLevels.value[locale.value].levels
  )

  const compVipTip = computed(() => comp[compId.value].vipTip)
  const compVipTips = computed(() => comp[compId.value].vipTips)
  const compPromotionTip = computed(() => comp[compId.value].promotionTip)
  const compVipArticle = computed(() => comp[compId.value].vipArticle)
  const compCustomerServiceEmail = computed(
    () => comp[compId.value].customerServiceEmail
  )
  const compCommunicationQRCodes = computed(
    () => comp[compId.value].communicationQRCodes
  )
  const compMobileGameCategories = computed(
    () => comp[compId.value].mobileGameCategories
  )
  const compFooterCopyright = computed(() => comp[compId.value].footerCopyright)
  const compFooterCopyrightHint = computed(
    () => comp[compId.value].footerCopyrightHint
  )
  const compMainMenu = computed(() => comp[compId.value].mainMenu)
  const compMainMenuSocialMediaList = computed(() =>
    comp[compId.value].mainMenuSocialMediaList.filter(
      mainMenuSocialMediaListItem => mainMenuSocialMediaListItem.enable
    )
  )
  const compMainMenuGameList = computed(() =>
    comp[compId.value].mainMenuGameList.filter(
      mainMenuGameListItem => mainMenuGameListItem.enable
    )
  )
  const compMainMenuInfoList = computed(() =>
    comp[compId.value].mainMenuInfoList.filter(
      mainMenuInfoListItem => mainMenuInfoListItem.enable
    )
  )
  const compMainMenuUserList = computed(() =>
    comp[compId.value].mainMenuUserList.filter(
      mainMenuUserListItem => mainMenuUserListItem.enable
    )
  )
  const compAgentLink = computed(() => comp[compId.value].agentLink)
  const compFaqLink = computed(() => comp[compId.value].faqLink[locale.value])
  const compUserIndex = computed(() => comp[compId.value].userIndex)
  const compAccountSetting = computed(() => comp[compId.value].accountSetting)
  const compFinancialService = computed(
    () => comp[compId.value].financialService
  )
  const compPromotionReceive = computed(
    () => comp[compId.value].promotionReceive
  )
  const compRecordQuery = computed(() => comp[compId.value].recordQuery)
  const compStationLetter = computed(() => comp[compId.value].stationLetter)
  const compCommon = computed(() => comp[compId.value].common)
  const compPromotion = computed(() => comp[compId.value].promotion)
  const compIdnPoker = computed(() => comp[compId.value].idnPoker)
  const compHasFeatureGames = computed(() => comp[compId.value].hasFeatureGames)
  const compHasFeatureGamesType = computed(
    () => comp[compId.value].hasFeatureGamesType
  )
  const compCheckIn = computed(() => compCommon.value.checkIn.enable)
  const compPlayGame = computed(() => comp[compId.value].playGame)
  const compIndexGameEntryList = computed(
    () => comp[compId.value].indexGameEntryList
  )
  const compIndexSafetyPlatforms = computed(
    () => comp[compId.value].indexSafetyPlatforms[locale.value]
  )
  const compIndexPaymentPlatforms = computed(
    () => comp[compId.value].indexPaymentPlatforms
  )
  const compIndexInfoList = computed(() => comp[compId.value].indexInfoList)
  const compIndexInfoTitle = computed(() => comp[compId.value].indexInfoTitle)
  const compIndexTutorial = computed(() => comp[compId.value].indexTutorial)
  const compIndexGuideList = computed(() => comp[compId.value].indexGuideList)

  const compMBottomMenu = computed(() => comp[compId.value].mBottomMenu)
  const compFooterSocialMedia = computed(
    () => comp[compId.value].footerSocialMedia
  )
  const compFooterLicense = computed(() => comp[compId.value].footerLicense)

  // wc(22)
  const compHeaderNavMenu = computed(() => comp[compId.value].headerNavMenu)
  const compMainMenuFindGameList = computed(
    () => comp[compId.value].mainMenuFindGameList
  )
  const compMainMenuPromotionList = computed(
    () => comp[compId.value].mainMenuPromotionList
  )
  const compMainMenuGuideList = computed(
    () => comp[compId.value].mainMenuGuideList
  )
  const compMainMenuOthersList = computed(
    () => comp[compId.value].mainMenuOthersList
  )
  const compMainMenuUserPagesList = computed(
    () => comp[compId.value].mainMenuUserPagesList
  )
  const compSiteGuideList = computed(() => comp[compId.value].siteGuideList)

  // 25
  const compMainMenuFirstList = computed(
    () => comp[compId.value].mainMenuFirstList
  )
  const compMainMenuSecondaryGameList = computed(
    () => comp[compId.value].mainMenuSecondaryGameList
  )
  const compMainMenuSecondarySupportList = computed(
    () => comp[compId.value].mainMenuSecondarySupportList
  )
  const compMenuSecondaryWalletList = computed(
    () => comp[compId.value].mainMenuSecondaryWalletList
  )
  const comMainBottomMenuList = computed(
    () => comp[compId.value].mainBottomMenuList
  )
  const comMainMenuSlideModalFirst = computed(
    () => comp[compId.value].mainMenuSlideModalFirst
  )
  const comMainMenuSlideModalSecondary = computed(
    () => comp[compId.value].mainMenuSlideModalSecondary
  )
  const comMainBottomMenuGameList = computed(
    () => comp[compId.value].mainBottomMenuGameList
  )
  const comMainBottomMenuWalletList = computed(
    () => comp[compId.value].mainBottomMenuWalletList
  )
  const comIndexBeginnerList = computed(
    () => comp[compId.value].indexBeginnerList
  )
  const compIndexSlotProvider = computed(
    () => comp[compId.value].indexSlotProvider
  )
  const compIndexProvider = computed(() => comp[compId.value].indexProvider)

  return {
    webEnv,
    isDev,
    locale,
    compId,
    compName,
    compAppLink,
    compAdultAge,
    compHead,
    compFooterPlatforms,
    compFooterPayments,
    compVipLevels,
    compVipLevelsList,
    compVipTip,
    compVipTips,
    compPromotionTip,
    compVipArticle,
    compCustomerServiceEmail,
    compCommunicationQRCodes,
    compMobileGameCategories,
    compFooterCopyright,
    compFooterCopyrightHint,
    compMainMenu,
    compMainMenuSocialMediaList,
    compMainMenuGameList,
    compMainMenuInfoList,
    compMainMenuUserList,
    compAgentLink,
    compFaqLink,
    compUserIndex,
    compAccountSetting,
    compFinancialService,
    compPromotionReceive,
    compRecordQuery,
    compStationLetter,
    compCommon,
    compPromotion,
    compIdnPoker,
    compHasFeatureGames,
    compHasFeatureGamesType,
    compCheckIn,
    compPlayGame,
    compIndexGameEntryList,
    compIndexSafetyPlatforms,
    compIndexPaymentPlatforms,
    compIndexInfoList,
    compIndexInfoTitle,
    compIndexTutorial,
    compIndexGuideList,
    compMBottomMenu,
    compFooterSocialMedia,
    compFooterLicense,
    // wc(22)
    compHeaderNavMenu,
    compMainMenuFindGameList,
    compMainMenuPromotionList,
    compMainMenuGuideList,
    compMainMenuOthersList,
    compSiteGuideList,
    compMainMenuUserPagesList,
    // mc(25)
    compMainMenuFirstList,
    compMainMenuSecondaryGameList,
    compMainMenuSecondarySupportList,
    compMenuSecondaryWalletList,
    comMainBottomMenuList,
    comMainBottomMenuGameList,
    comMainBottomMenuWalletList,
    comMainMenuSlideModalFirst,
    comMainMenuSlideModalSecondary,
    comIndexBeginnerList,
    compIndexSlotProvider,
    compIndexProvider
  }
}
